/**
 * This is the vertex shader for the "raster" program.
 * 
 * It takes in positions and transforms them using a matrix supplied by mapbox.
 * It also passes through the texture coordinates for the fragment shader.
 */

attribute vec2 aPos; // We use this to pass in the positions of the vertices.
uniform mat4 uMatrix; // We use this to pass in the matrix that will be used to transform the vertices

varying vec2 vTexCoord; // We use this to pass the texture coordinates to the fragment shader

/**
 * This is the scaling factor of mapbox tiles. For reference, see the following:
 * - https://github.com/mapbox/mapbox-gl-js/blob/acc665f77fa6852c11c3755f69afcb781c15b7cd/src/shaders/_prelude.vertex.glsl#L3
 * - https://github.com/mapbox/mapbox-gl-js/blob/acc665f77fa6852c11c3755f69afcb781c15b7cd/src/shaders/globe_raster.vertex.glsl#L49
 * - https://github.com/mapbox/mapbox-gl-js/blob/f2117b4ef501bbab298898e4f6c34083178d519a/src/data/extent.js
 */
float Extent = 8192.0;

void main() {
  // Transform the vertex position via the matrix & extent:
  gl_Position = uMatrix * vec4(aPos * Extent, 0, 1);

  // Pass the texture coords through for the fragment shader:
  vTexCoord = aPos;
}
